var _defs, _path, _rect, _path2, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.21 93.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d9d9d9;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tacho de basura") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M591.49,358.9v46.9A14.48,14.48,0,0,1,577,420.28H548.18a14.48,14.48,0,0,1-14.49-14.48V358.9a3.6,3.6,0,0,0-3.59-3.6h0a3.6,3.6,0,0,0-3.6,3.6v46.56a22,22,0,0,0,22,22h28.16a22,22,0,0,0,22-22V358.9a3.6,3.6,0,0,0-3.6-3.6h0A3.6,3.6,0,0,0,591.49,358.9Z",
    transform: "translate(-526.5 -334.18)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 21.76,
    y: 28.38,
    width: 7.04,
    height: 43.12,
    rx: 3.52
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M576.93,337.7h0a3.52,3.52,0,0,0-3.52-3.52H551.85a3.53,3.53,0,0,0-3.52,3.52h0a3.52,3.52,0,0,1-3.52,3.52H530.07a3.52,3.52,0,0,0-3.52,3.52h0a3.51,3.51,0,0,0,3.52,3.52H595.2a3.52,3.52,0,0,0,3.52-3.52h0a3.53,3.53,0,0,0-3.52-3.52H580.45A3.52,3.52,0,0,1,576.93,337.7Z",
    transform: "translate(-526.5 -334.18)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 43.47,
    y: 28.38,
    width: 7.04,
    height: 43.12,
    rx: 3.52
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.6abe850204d8d5d612691feeb5f2b425.svg";
export { ForwardRef as ReactComponent };